import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { forwardRef, memo, useCallback, useState } from 'react';

const ConfirmDialog = memo(
  forwardRef(
    (
      {
        handleYes,
        handleLogout = null,
        onClose = null,
        title = 'Confirmation!',
        content = 'Are you sure you want to call customer?'
      },
      ref
    ) => {
      const [open, setOpen] = useState(false);

      const handleOpen = useCallback(() => setOpen(true), []);
      const handleClose = useCallback(() => {
        onClose && onClose();
        setOpen(false);
      }, [onClose]);

      if (ref) {
        !ref.current && (ref.current = {});
        ref.current.handleOpen = handleOpen;
        ref.current.handleClose = handleClose;
        ref.current.open = open;
      }

      return (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'>
          <DialogTitle className='text-center'>{title}</DialogTitle>
          <DialogContent className='px-5'>{content}</DialogContent>
          <DialogActions className='justify-content-center mb-2'>
            <button
              className='btn btn-primary px-4'
              onClick={() => {
                handleClose();
                handleYes();
              }}>
              Yes
            </button>
            <button
              className='btn btn-primary px-4 ml-4  decline-btn'
              onClick={() => {
                handleClose();
                if (handleLogout) {
                  handleLogout();
                }
              }}>
              No
            </button>
          </DialogActions>
        </Dialog>
      );
    }
  )
);

export default ConfirmDialog;
